import type { ImageMap, UUID } from '../types';

export interface EnvelopeCertificate {
  carbonCopyEvents: CarbonCopyEvent[];
  envelopeMeta: EnvelopeMeta;
  fileDetails: FileDetail[];
  imageMap: ImageMap;
  signerEvents: SignerEvent[];
}

export interface CarbonCopyEvent {
  displayName: string;
  email: string;
  firstSentAt: Date | null;
  userAuthentication: AuthenticationType;
  viewedAt: Date | null;
}

export interface SignerEvent extends CarbonCopyEvent {
  signatures: Signature[];
  signedAt: Date | null;
  signingIpAddress: string | null;
  signLocation: string;
}

export interface Signature {
  documentId: UUID;
  fieldId: UUID;
  signatureImgId: UUID;
}

export interface FileDetail {
  name: string;
}
export interface EnvelopeMeta {
  envelopeCreator: EnvelopeCreator;
  envelopeId: UUID;
  status: string;
  timeZone: string;
  title: string;
}

export interface EnvelopeCreator {
  displayName: string;
  email: string;
  id: string;
}

export type AuthenticationType = 'email-only' | 'password' | null;

export const dateFormatString = "yyyy-MM-dd hh:mm:ss 'UTC";

export const certificateSignerEventTabOrder: (null | keyof SignerEvent)[] = [
  // Row 1
  'displayName',
  'signingIpAddress',
  'firstSentAt',
  // Row 2
  'email',
  'signatures',
  'viewedAt',
  // Row 3
  null,
  null,
  'signedAt',
];

export const envCertificateValuePrefix: Record<keyof SignerEvent, string> = {
  displayName: '',
  email: '',
  firstSentAt: 'Sent at: ',
  signLocation: '',
  signatures: '',
  signedAt: 'Signed at: ',
  signingIpAddress: 'IP Address: ',
  userAuthentication: '',
  viewedAt: 'Viewed at: ',
};
